import {charcoal} from '../sass/base/_exports.sass';

export const EyeDropIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 40;
  const height = 40;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 19V13H21V19H27V21H21V27H19V21H13V19H19Z" fill={color} />
      <rect
        x="1.5"
        y="1.5"
        width="37"
        height="37"
        rx="18.5"
        stroke="url(#paint0_linear_7777_7262)"
        strokeWidth="3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7777_7262"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0000" />
          <stop offset="0.171875" stopColor="#FF8A00" />
          <stop offset="0.307292" stopColor="#FFE600" />
          <stop offset="0.46875" stopColor="#38D600" />
          <stop offset="0.598958" stopColor="#0085FF" />
          <stop offset="0.765625" stopColor="#2A0CE3" />
          <stop offset="1" stopColor="#EE00F3" />
        </linearGradient>
      </defs>
    </svg>
  );
};
